const actionTypeIdentifier = "D6B7A2F1-2C48-4E9F-B4F2-5DFA84718C1A";

export const setOutputConfigHistoryLogsLoading = `SET-OUTPUTCONFIG-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getOutputConfigHistoryLogs = `GET-OUTPUTCONFIG-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setOutputConfigHistoryPageSize = `SET-OUTPUTCONFIG-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetOutputConfigHistory = `RESET-OUTPUTCONFIG-HISTORY-${actionTypeIdentifier}`;
export const setOutputConfigHistoryColSearchStr = `SET-OUTPUTCONFIG-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;